import { render, staticRenderFns } from "./serviceDetail.vue?vue&type=template&id=5bf01572&scoped=true"
import script from "./serviceDetail.vue?vue&type=script&lang=js"
export * from "./serviceDetail.vue?vue&type=script&lang=js"
import style0 from "./serviceDetail.vue?vue&type=style&index=0&id=5bf01572&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf01572",
  null
  
)

export default component.exports